import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef, startTransition } from "react";
import { HeaderElement } from "./Header";
import { ForwardFlipCSS, BackwardFlipCSS, HeaderPosition, CoverAnimation } from "./PageAnimations";

export let PagenumValue;

export let LeftPage = {
    LeftPage: 0,
    get GetPage() { // ALT function name: GetThatBoogie (courtesy of Joe lul)
        return this.LeftPage;
    },
    /**
     * @param {number} Number
     */
    set SetPage(Number) {
        this.LeftPage = Number;
    },
    /**
     * @param {number} Number
     */
    set IncrementPage(Number) {
        this.LeftPage += Number;
    },
    /**
     * @param {number} Number
     */
    set DecrementPage(Number) {
        this.LeftPage = Number - 1;
    }
};

export let RightPage = {
    RightPage: 0,
    get GetPage() {
        return this.RightPage;
    },
    /**
     * @param {number} Number
     */
    set SetPage(Number) {
        this.RightPage = Number;
    }, 
    /**
     * @param {number} Number
     */
    set IncrementPage(Number) {
        this.RightPage = Number + 1;
    },
    /**
     * @param {number} Number
     */
    set DecrementPage(Number) {
        this.RightPage -= Number;
    }
};

function Navbar() {  
    return (
        <>
            <Footer />
        </>
    );
}

function Footer() {  
    const navigate = useNavigate(); // For redirecting the URL.
    let [pagenums, setPagenums] = useState(0); // For setting the book's page number.
    const [clicked, setClicked] = useState({
        left: true,
        right: false,
        back: false
    }); // For recording consecutive button presses.
   
    /*For setting the title of the footer buttons. */
    const [leftButtonTitle, setLeftButtonTitle] = useState("N/A (Press Opposite Arrow!)");
    const [rightButtonTitle, setRightButtonTitle] = useState("Open Book From Front"); 
    const prevPagenums = useRef(0);

    console.debug("Value of click defaults (Footer): " 
        + clicked.left + ", " + clicked.right + ", and " + clicked.back);
    //console.debug("Value of FooterEnable (Footer): " + FooterEnable);
    //setClicked(FooterEnable);

    PagenumValue = pagenums;

    console.debug("Pagenums value for use in other files: " + PagenumValue);
   
    let HeaderClickValue = HeaderElement.GetHeader;
    console.debug("HeaderClickValue footer: " + HeaderClickValue);

    console.debug("Initial Value of LeftPage: " + LeftPage.GetPage);
    console.debug("Initial Value of RightPage: " + RightPage.GetPage);

  

    // Change the value of the page's number through checking the current URL and updating as needed.
    // NOTE: this only returns pagenums upon clicking the header button once. Need to fix later.

    useEffect(() => {
        console.debug("Pagenums value in useEffect footer 1: " + prevPagenums.current);
        //console.debug("Previous Pagenums Value #1: " + prevPagenums.current);

        // Insert Page Animation functions to each condition below
        // ex. PageFlipCSS(pagenums)
        // If the location is the frontpage, pagenums becomes set to 0.
        if (HeaderClickValue === "BoA-header-logo") {
            prevPagenums.current = 0;
            setPagenums(prevPagenums.current);
            setClicked({ // Set back to default values.
                left: true,
                right: false,
                back: false
            });
            setLeftButtonTitle("N/A (Press Opposite Arrow!)");
            setRightButtonTitle("Open Book From Front");
            console.debug("Pagenums value when on Homepage URL: " + prevPagenums.current);
        // If the location is the artwork, pagenums becomes set to 3.
        } else if (HeaderClickValue === "BoA-header-artwork") {
            prevPagenums.current = 3;
            setPagenums(prevPagenums.current);   
            //setClicked(FooterEnable);    
            //console.debug("Value of click after header button pressed (Footer): " + clicked);
            setClicked({ // Reset all footer buttons to false.
                left: false,
                right: false,
                back: false
            });
            setLeftButtonTitle("Flip Left Page");
            setRightButtonTitle("Flip Right Page");
            console.debug("Pagenums value when on Artwork URL: " + prevPagenums.current);
        // If the location is the coding, pagenums becomes set to 6.
        } else if (HeaderClickValue === "BoA-header-coding-projects") {
            prevPagenums.current = 6;
            setPagenums(prevPagenums.current);
            setClicked({ // Reset all footer buttons to false.
                left: false,
                right: false,
                back: false
            });
            setLeftButtonTitle("Flip Left Page");
            setRightButtonTitle("Flip Right Page");
            console.debug("Pagenums value when on Coding Projects URL: " + prevPagenums.current);
        // If the location is the writing, pagenums becomes set to 11.
        } else if (HeaderClickValue === "BoA-header-writing") {
            prevPagenums.current = 11;
            setPagenums(prevPagenums.current);
            setClicked({ // Reset all footer buttons to false.
                left: false,
                right: false,
                back: false
            });
            setLeftButtonTitle("Flip Left Page");
            setRightButtonTitle("Flip Right Page");
            console.debug("Pagenums value when on Writing URL: " + prevPagenums.current);
        // If the location is the about, pagenums becomes set to 12.
        } else if (HeaderClickValue === "BoA-header-about") {
            prevPagenums.current = 12;
            setPagenums(prevPagenums.current);
            setClicked({ // Reset all footer buttons to false.
                left: false,
                right: false,
                back: false
            });
            setLeftButtonTitle("Flip Left Page");
            setRightButtonTitle("Flip Right Page");
            console.debug("Pagenums value when on About URL: " + prevPagenums.current);
        } 
    
        console.debug("Pagenums value in useEffect footer 2: " + prevPagenums.current);
        //console.debug("Previous Pagenums Value #2: " + prevPagenums.current);

    }, [HeaderClickValue]);

    /* Disable and enable footer buttons based on the value in the header.
    if (FooterEnable === true) {
         setClicked(FooterEnable);
     } */
 
    /** Flipping the pages forward via incrementation and useNavigate */
    function FlipPageForward() {
        pagenums++;
        LeftPage.IncrementPage = 2;
        RightPage.IncrementPage = LeftPage.GetPage;
        HeaderElement.SetHeader = "N/A"; // Reset header value to allow pagenums in useEffect to initialize. 

        //useHeaderEnable(HeaderElement.SetHeader);
        
        console.debug("LeftPage: " + LeftPage.GetPage);
        console.debug("RightPage: " + RightPage.GetPage);

        console.debug("Pagenums after button press (front): " + pagenums);
        
        setClicked({
            left: true,
            right: true,
            back: true
        }); // Disable button after clicking once to prevent multiple button clicks.
        
        console.debug("Value of click before (front left): " + clicked.left);
        console.debug("Value of click before (front right): " + clicked.right);

        /* Return pagenums when above 15 to prevent numbers beyond the book
        pages and maintain position on the back page (back book cover).
        1/12/26 EDIT: No longer following approach. Disable right button on back cover instead. 
        OLD CODE:
        if (pagenums === 15) {
            setClicked({
                left: false,
                right: true // Disable right button.
            });
            return;
        } else {//}*/

        setPagenums(pagenums);
        startTransition(() => {
            ForwardFlipCSS(pagenums);
        });
        
        /*May have to delete depending on page flip animations. */
            switch(pagenums) {
                case 1:
                    LeftPage.SetPage = 0;
                    RightPage.SetPage = 1;
                    CoverAnimation(pagenums);
                    setTimeout(() => {
                        navigate("/frontpage");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                        setLeftButtonTitle("Close Book");
                        setRightButtonTitle("Flip Right Page");
                    }, 2000);
                    break;
                case 2: 
                    setTimeout(() => {
                        navigate("/tableofcontents");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right); 
                        setLeftButtonTitle("Flip Left Page");
                        setRightButtonTitle("Flip Right Page");
                    }, 800);
                    break;
                case 3:
                    setTimeout(() => {
                        navigate("/artwork");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);                    
                    }, 800);
                    break;
                case 4:
                    setTimeout(() => {
                        navigate("/artwork-2");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);                    
                    }, 800);
                    break;
                case 5:
                    setTimeout(() => {
                        navigate("/artwork-3");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break;
                case 6:
                    setTimeout(() => {
                        navigate("/codingprojects");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break;
                case 7:
                    setTimeout(() => {
                        navigate("/codingprojects-2");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break; 
                case 8:
                    setTimeout(() => {
                        navigate("/codingprojects-3");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break;   
                case 9:
                    setTimeout(() => {
                        navigate("/codingprojects-4");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break;
                case 10:
                    setTimeout(() => {
                        navigate("/codingprojects-5");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break;
                case 11:
                    setTimeout(() => {
                        navigate("/writing");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break;
                case 12:
                    setTimeout(() => {
                        navigate("/about");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break;
                case 13:
                    setTimeout(() => {
                        navigate("/about-2");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                    }, 800);
                    break;
                case 14:  
                    setTimeout(() => {
                        navigate("/backpage");
                        setClicked(false);
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                        setLeftButtonTitle("Flip Left Page");
                        setRightButtonTitle("Close Book");
                    }, 800);
                    break;
                case 15:
                    CoverAnimation(pagenums);
                    setTimeout(() => {
                        navigate("/backcover");
                        setClicked({
                            left: false,
                            right: true, // Disable right button.
                            back: false 
                        });                        
                        console.debug("Value of click after (front left): " + clicked.left);
                        console.debug("Value of click after (front right): " + clicked.right);
                        setLeftButtonTitle("Open Book From Back");
                        setRightButtonTitle("N/A (Press Opposite Arrow!)");
                    }, 2000);
                    break;
                default:
                    return pagenums;
                    }
                };           

    /** Flipping the pages forward via decrementation and useNavigate */
    function FlipPageBackward() {
        pagenums--;
        RightPage.DecrementPage = 2;
        LeftPage.DecrementPage = RightPage.GetPage;
        HeaderElement.SetHeader = "N/A"; // Reset header value to allow pagenums in useEffect to initialize. 

        console.debug("Pagenums after button press (back): " + pagenums);

        setClicked({
            left: true,
            right: true,
            back: true
        }); // Disable button after clicking once to prevent multiple button clicks.

        console.debug("Value of click before (front left): " + clicked.left);
        console.debug("Value of click before (front right): " + clicked.right);
        
        /* Return pagenums when below 0 to prevent negative numbers and 
        maintain position on the front page (front book cover). 
        1/12/26 EDIT: No longer following approach. Disable left button on front cover instead. 
        OLD CODE:
        if (pagenums === 0) {
            setClicked({
                left: true,
                right: false,
                back: false
            });
            return;
        } else {//}*/
        setPagenums(pagenums);
        BackwardFlipCSS(pagenums);
       

        /*May have to delete depending on page flip animations. */
        switch(pagenums) {
            case 15:
                CoverAnimation(pagenums);
                setTimeout(() => {
                    navigate("/backcover");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                    setLeftButtonTitle("Open Book From Back");
                    setRightButtonTitle("N/A (Press Opposite Arrow!)");
                }, 2000);
                break;
            case 14:
                LeftPage.SetPage = 26;
                RightPage.SetPage = 27;
                CoverAnimation(pagenums);
                setTimeout(() => {
                    navigate("/backpage");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                    setLeftButtonTitle("Flip Left Page");
                    setRightButtonTitle("Close Book");
                }, 2000);
                break;    
            case 13:
                setTimeout(() => {
                    navigate("/about-2");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                    setLeftButtonTitle("Flip Left Page");
                    setRightButtonTitle("Flip Right Page");
                }, 800);
                break;
            case 12:
                setTimeout(() => {
                    navigate("/about");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;
            case 11:
                setTimeout(() => {
                    navigate("/writing");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;
            case 10:
                setTimeout(() => {
                    navigate("/codingprojects-5");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;
            case 9:
                setTimeout(() => {
                    navigate("/codingprojects-4");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break; 
            case 8:
                setTimeout(() => {
                    navigate("/codingprojects-3");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break; 
            case 7:
                setTimeout(() => {
                    navigate("/codingprojects-2");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;  
            case 6:
                setTimeout(() => {
                    navigate("/codingprojects");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;
            case 5:
                setTimeout(() => {
                    navigate("/artwork-3");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;
            case 4:
                 setTimeout(() => {
                    navigate("/artwork-2");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;
            case 3:
                setTimeout(() => {
                    navigate("/artwork");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;
            case 2:
                setTimeout(() => {
                    navigate("/tableofcontents");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                }, 800);
                break;
            case 1:
                setTimeout(() => {
                    navigate("/frontpage");
                    setClicked(false);
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                    setLeftButtonTitle("Close Book");
                    setRightButtonTitle("Flip Right Page");
                }, 800);
                break;
            case 0:
                CoverAnimation(pagenums);
                setTimeout(() => {
                    navigate("/");
                    setClicked({
                        left: true,
                        right: false,
                        back: false
                    });
                    console.debug("Value of click after (back left): " + clicked.left);
                    console.debug("Value of click after (back right): " + clicked.right);
                    setLeftButtonTitle("N/A (Press Opposite Arrow!)");
                    setRightButtonTitle("Open Book From Front");
                }, 2000);
                break;
            default:
                return pagenums;
                }
            }; 

    function MinorBackCover() {
        const handleClick = event => {
        HeaderClickValue = event.currentTarget.id;
        setClicked({
            left: true,
            right: true,
            back: true
        }); // Disable button after clicking once to prevent multiple button clicks.

        if (HeaderClickValue === "BoA-footer-logo") {
            LeftPage.SetPage = 28;
            RightPage.SetPage = 29;
            HeaderPosition(HeaderClickValue, pagenums);
            setTimeout(() => {
                navigate("/backcover");
                setClicked({
                    left: false,
                    right: true,
                    back: false
                }); // Disable button after clicking once to prevent multiple button clicks.                
                setLeftButtonTitle("Open Book From Back");
                setRightButtonTitle("N/A (Press Opposite Arrow!)");
                HeaderElement.SetHeader = "N/A"; // Reset header value to allow pagenums in useEffect to initialize. 
            }, 1500); 
            pagenums = 15;
            console.debug("Pagenums value when on Backcover URL: " + pagenums);
            setPagenums(pagenums);
           // HeaderPosition(HeaderClickValue, pagenums);
            }
        };        
        return handleClick;
    }

return (
                /* TODO: page flip navigation + animation 
                    <button className="BoA-footer-buttons" id="BoA-footer-left"></button>
                    <button className="BoA-footer-buttons" id="BoA-footer-right"></button>
                    */

     <footer className="Book-of-Abdul-Footer">
        {/* <div className="Book-of-Abdul-Bookmark-Footer"> */}
            <div className="BoA-Buttons-Footer"> 
                {/* <figure className="BoA-Button-Decorations">
                    <img id="BoA-button-dec-footer" src={ButtonDecorationFooter} alt={footdecor.title}/>
                </figure> */}

                <nav id="BoA-button-layout-footer">
                    <button onClick={FlipPageBackward}
                        disabled={clicked.left} 
                        className="BoA-footer-buttons" 
                        id="BoA-footer-button-left" 
                        type="button" 
                        title={leftButtonTitle}>
                        <div className="BoA-footer-arrows"> 
                            <div id="BoA-footer-arrow-left"/>
                        </div>
                    </button>
                    
                    <button onClick={FlipPageForward}
                        disabled={clicked.right} 
                        className="BoA-footer-buttons" 
                        id="BoA-footer-button-right" 
                        type="button" 
                        title={rightButtonTitle}>
                        <div className="BoA-footer-arrows">
                            <div id="BoA-footer-arrow-right"/>
                        </div> 
                    </button>
                </nav>
            </div>
             
            <div className="BoA-Footer-Logo-Button">
                <button onClick={MinorBackCover()}
                    disabled={clicked.back}
                    id="BoA-footer-logo" 
                    type="button"
                    title="Go to Backcover">
                </button>
            </div> 
        {/* </div> */}
    </footer>
  );
} 
 export default Navbar;

 // Old code I no longer need for now, but keeping just in case.
 //import ButtonDecorationFooter from "./photos/BookDecorPNG/BookofAbdul_ButtonDecorations(Footer).png";

     // const footdecor = 
    //     {
    //       title: "ButtonDecorationFooter",
    //       photo: ButtonDecorationFooter
    //     };

 /**
  * 
  * function PageIncrement(page) {
  * let navigate = useNavigate(); See if I can invoke here or on the Footer function.

  * page++;

    console.debug("Pagenums after button press: " + pagenums);
    if (pagenums === 1) {
        navigate("/frontpage");
     } else if (pagenums === 2)
        navigate("/tableofcontents");
        
    }    
        */


     // console.debug("Pagenums after button press: " + pagenums);
                        
                        // if (pagenums === 1) {
                        //     navigate("/frontpage");
                        //     pagenums++;
                        // }

                        //     console.debug("Pagenums after button press: " + pagenums);
                        //      if (pagenums === 1) {
                        //          navigate("/frontpage");
                        //          console.debug("Reached frontpage: " + pagenums); 
                        //          pagenums++;
                        //          console.debug("Pagenums after button press 2: " + pagenums);
                        //      } else if (pagenums === 2) {
                        //         console.debug("Pagenums after button press 2: " + pagenums);
                        //         navigate("/tableofcontents");
                        //          console.debug("Reached ToC: " + pagenums); 
                        //      } else {
                        //         pagenums++;
                        //         return pagenums;
                        // }

                          
                       /* switch(i) {
                           case 1:
                                navigate("/frontpage");
                                break;
                           case 2:
                                navigate("/tableofcontents");
                                break;
                           case 13:
                                break;
                           default:
                                console.debug("Value of (i): " + i);
                                break;
                                }
                                break;
                            } */
                                
                        
/** Page Flip Navigation Functions: Original Versions with If/Else
 * 
 *  // Flipping the pages forward via incrementation and useNavigate 
 function FlipPageForward() {
    console.debug("Pagenums before button press: " + pagenums);
    setPagenums(pagenums++);
    console.debug("Pagenums after button press: " + pagenums);
    if (pagenums === 1) {
        navigate("/frontpage");
        console.debug("Reached frontpage: " + pagenums);
        setPagenums(pagenums);
    } else if (pagenums === 2) {
        console.debug("Pagenums after button press 2: " + pagenums);
        navigate("/tableofcontents");
        console.debug("Reached ToC: " + pagenums);
        setPagenums(pagenums);
    }
  };

// Flipping the pages forward via decrementation and useNavigate 
function FlipPageBackward() {
    console.debug("Pagenums before button press: " + pagenums);
    setPagenums(pagenums--);
    console.debug("Pagenums after button press: " + pagenums);
    if (pagenums === 2) {
        console.debug("Pagenums after button press 2: " + pagenums);
        navigate("/tableofcontents");
        console.debug("Reached ToC (backwards): " + pagenums);
        setPagenums(pagenums);
    } else if (pagenums === 1) {
        navigate("/frontpage");
        console.debug("Reached frontpage (backwards): " + pagenums);
        setPagenums(pagenums);
    } else if (pagenums === 0) {
        navigate("/");
        setPagenums(pagenums = 0);
        return pagenums;
    } 
  };
 */
    
    /*Omitting const due to changes in my header button from an <img> to a <button>.  
    const backlogo = 
        {
            title: "BookofAbdulBackLogo",
            photo: BookofAbdulBackLogo
        };
    */